import "../css/termsConditions.css";
import {
  FaFileContract,
  FaUserShield,
  FaShoppingCart,
  FaCreditCard,
  FaTruck,
  FaUndo,
  FaBan,
  FaGavel
} from "react-icons/fa";

function TermsConditions() {
  return (
    <div className="terms-page">

      {/* Hero */}

      <section className="terms-hero">

        <div className="terms-overlay">

          <h1>Terms & Conditions</h1>

          <p>
            Please read these Terms and Conditions carefully before using
            the SIP LIQUORS website and placing an order.
          </p>

        </div>

      </section>

      {/* Introduction */}

      <section className="terms-section">

        <div className="terms-container">

          <h2>Agreement</h2>

          <p>
            By accessing or using SIP LIQUORS, you agree to comply with
            these Terms and Conditions. If you do not agree with any part
            of these terms, please discontinue using our website.
          </p>

        </div>

      </section>

      {/* Cards */}

      <section className="terms-section gray">

        <div className="terms-container">

          <div className="terms-grid">

            <div className="terms-card">
              <FaUserShield className="terms-icon"/>
              <h3>Eligibility</h3>
              <p>
                Customers must meet the legal drinking age required in
                their jurisdiction to purchase alcoholic products.
              </p>
            </div>

            <div className="terms-card">
              <FaShoppingCart className="terms-icon"/>
              <h3>Orders</h3>
              <p>
                Orders are subject to product availability and order
                verification before processing.
              </p>
            </div>

            <div className="terms-card">
              <FaCreditCard className="terms-icon"/>
              <h3>Payments</h3>
              <p>
                All payments must be completed using approved secure
                payment methods before shipping.
              </p>
            </div>

            <div className="terms-card">
              <FaTruck className="terms-icon"/>
              <h3>Shipping</h3>
              <p>
                Delivery times are estimates and may vary depending on
                your location and local regulations.
              </p>
            </div>

            <div className="terms-card">
              <FaUndo className="terms-icon"/>
              <h3>Returns</h3>
              <p>
                Returns and refunds are processed according to our Return
                Policy and applicable laws.
              </p>
            </div>

            <div className="terms-card">
              <FaBan className="terms-icon"/>
              <h3>Restricted Use</h3>
              <p>
                You may not misuse the website or engage in fraudulent,
                unlawful, or abusive activities.
              </p>
            </div>

          </div>

        </div>

      </section>

      {/* Important Rules */}

      <section className="terms-section">

        <div className="terms-container">

          <h2>Important Conditions</h2>

          <ul className="terms-list">

            <li>✔ Prices may change without prior notice.</li>

            <li>✔ Orders may be cancelled if payment verification fails.</li>

            <li>✔ Customers are responsible for providing accurate delivery information.</li>

            <li>✔ Age verification may be required during delivery.</li>

            <li>✔ Product images are for illustration purposes only.</li>

            <li>✔ SIP LIQUORS reserves the right to refuse service when required by law.</li>

          </ul>

        </div>

      </section>

      {/* Legal */}

      <section className="terms-bottom">

        <div className="terms-container">

          <FaFileContract className="bottom-icon"/>

          <h2>Legal Compliance</h2>

          <p>
            These Terms and Conditions are governed by applicable laws.
            SIP LIQUORS reserves the right to modify these terms at any
            time without prior notice.
          </p>

          <FaGavel className="bottom-gavel"/>

        </div>

      </section>

    </div>
  );
}

export default TermsConditions;